import React, { useContext } from 'react';

import { AnswerContext } from '../index';
// import { Container } from './styles';

function Resume() {
  const { state, dispatch } = useContext(AnswerContext);

  return (
    <>
      {state.nameShow && (
        <p>
          Pergunta: <br /> - {state.nameShow}
        </p>
      )}
      {state.name && (
        <p>
          Descrição no detalhe: <br /> - {state.name}
        </p>
      )}
      {state.required !== null &&
        (state.required ? (
          <p>
            O item é <strong>obrigatório</strong>
          </p>
        ) : (
          <p>
            O item <strong>não é obrigatório</strong>
          </p>
        ))}
    </>
  );
}

export default Resume;
